import { render, staticRenderFns } from "./LoadErrorCard.vue?vue&type=template&id=cf353be8&scoped=true&"
import script from "./LoadErrorCard.vue?vue&type=script&lang=ts&"
export * from "./LoadErrorCard.vue?vue&type=script&lang=ts&"
import style0 from "./LoadErrorCard.vue?vue&type=style&index=0&id=cf353be8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf353be8",
  null
  
)

export default component.exports